import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Header = ({ onPrevDay, onNextDay, currentDate, user, onLogout }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleMenuItemClick = () => {
    // Close dropdown when menu item is clicked
    setIsDropdownOpen(false);
  };

  return (
    <header>
      <div className="header-top mb-50">
        {/* <h1>Task Timeline</h1> */}
        {user && (
          <div className="user-menu">
            <span className="username fw-bolder">Hello, {user.username || user.first_name || 'User'}</span>
            <div className="dropdown" ref={dropdownRef}>
              <button 
                className="dropdown-toggle"
                onClick={toggleDropdown}
                aria-expanded={isDropdownOpen}
              >
                <i className="fas fa-user-circle"></i>
              </button>
              <div className={`dropdown-menu ${isDropdownOpen ? 'show' : ''}`}>
                <Link to="/dashboard" className="dropdown-item" onClick={handleMenuItemClick}>
                  <i className="fas fa-home"></i> Dashboard
                </Link>
                <Link to="/project-manager" className="dropdown-item" onClick={handleMenuItemClick}>
                  <i className="fas fa-project-diagram"></i> Projects
                </Link>
                <Link to="/user-manager" className="dropdown-item" onClick={handleMenuItemClick}>
                  <i className="fas fa-users"></i> Users
                </Link>
                <Link to="/invites" className="dropdown-item" onClick={handleMenuItemClick}>
                  <i className="fas fa-envelope"></i> Invites
                </Link>
                <button onClick={() => { onLogout(); handleMenuItemClick(); }} className="dropdown-item">
                  <i className="fas fa-sign-out-alt"></i> Logout 
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      
      <div className="current-date">{currentDate}</div>
      <div className="navigation">
        <button id="prev-day" className="nav-btn" onClick={onPrevDay}>
          <i className="fas fa-chevron-left"></i> Previous Day
        </button>
        <button id="next-day" className="nav-btn" onClick={onNextDay}>
          Next Day <i className="fas fa-chevron-right"></i>
        </button>
      </div>
    </header>
  );
};

export default Header; 